module.exports = __webpack_public_path__ + "static/media/Loading.1eaf6a27.svg";